import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Pagination from "../General/Pagination";
import Monthly_navbar from "./Monthlytasks_navbar";
import { scrollToTop } from "../Shared/ScrollOnTop";

const ManageMonth = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false);
  const [deleteLoadingId, setDeleteLoadingId] = useState(0);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    document.title = "Manage Posted Fee";

    setIsUpdated(false);
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      SchoolID: 1,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "MonthlyTask/GetStartedMonths",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        ////console.log(response.data);
        setLedger(response.data.ListofRecords);
        setLoading(false);
        setTotalRecords(response.data.totalRecords);
      })
      .catch(function (error) {
        ////console.log(error);
      });
  }, [pageNo, pageSize, isUpdated]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      //console.log(listOfLedger)
      let count = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)}</td>
            <td>{item.Month_ID}</td>
            <td>{item.Month_Number}</td>
            <td>{item.Current_Year}</td>
            <td style={{ maxWidth: "612px" }}>{item.Class_Name}</td>
            <td>{item.Total_Students}</td>
            <td >
              {moment(item.Started_On).format(config.date_format)}
            </td>
            <td>{item.User_Name}</td>
            <td className="text-center">
              <ul
                className="inline-action"
                aria-labelledby="dropdownMenuButton1"
              >

                <li>
                  <NavLink
                    to={
                      "/MonthlyTasks/MonthDetails/?Month=" +
                      item.Month_Number +
                      "&Year=" +
                      item.Current_Year +
                      "&ReferenceID=" + item.Month_ID
                    }
                    className="blue"
                  >
                    <i className="ri-pages-line"></i>
                  </NavLink>
                </li>
                <li>
                  <button
                    type="button"
                    className="btn btn-link p-0 text-danger"
                    disabled={deleteLoadingId === item.Month_ID}
                    onClick={() => handleDelete(item)}
                    title="Delete Posted Fee"
                  >
                    {deleteLoadingId === item.Month_ID ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <i className="ri-delete-bin-line"></i>
                    )}
                  </button>
                </li>
              </ul>

            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="9">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  const handleDelete = (item) => {
    const confirmDelete = window.confirm(
      "This will delete posted fee for the selected month and mark related ledger and challans as deleted. Continue?"
    );
    if (!confirmDelete) {
      return;
    }

    setDeleteLoadingId(item.Month_ID);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: item.Month_ID,
      SelectedMonth: item.Month_Number,
      FYear: item.Current_Year,
    };
    const api_config = {
      method: "post",
      url: config.base_url + "MonthlyTask/DeletePostedMonth",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsUpdated(true);
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function () {
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(function () {
        setDeleteLoadingId(0);
      });
  };

  return (
    <>
      <Monthly_navbar />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/MonthlyTasks/MonthlyTasksDashboard">
                      Fee Posting
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Manage Posted Fee
                  </li>
                </ol>
              </nav>
              <div className="page-title">Manage Posted Fee</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/MonthlyTasks/StartNewMonth"
                  className="button button-white button-icon"
                >
                  Post Fee
                  <i className="ri-add-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <div>
                <table className="table table-theme table-hover">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Posting Code</th>
                      <th>Month</th>
                      <th>Year</th>
                      <th>Classes</th>
                      <th>Total Student</th>
                      <th >Started On</th>
                      <th>User Name</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="9">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : (
                      <>{renderLedger()}</>
                    )}
                  </tbody>
                </table>
                {totalRecords > 3 && (
                  <div className="pagination-wrap">
                    <div className="row align-items-center">
                      <div className="col-md-2 form_default">
                        <div className="d-flex align-items-center">
                          <label className="me-2" style={{ fontSize: "15px" }}>
                            Page Size
                          </label>
                          <div className="form-group">
                            <select
                              className="form-select"
                              style={{ width: "100px" }}
                              onChange={(e) => {
                                setPageNo(1);
                                setPageSize(parseInt(e.target.value));
                              }}
                            >
                              <option value="10" selected>
                                10
                              </option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <Pagination
                        pageNo={pageNo}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageMonth;
